/** @prettier */

import baseFetch from '../baseFetch';

export const fetchSessionsClip = (clipId, cookies) =>
  baseFetch(`/sessions/clips/${clipId}?`, { cookies });

export const fetchSession = (sessionId, cookies) =>
  baseFetch(`/sessions/${sessionId}/details?`, { cookies });
